import { render, staticRenderFns } from "./stories_inner.vue?vue&type=template&id=6aa0ba68&scoped=true"
import script from "./stories_inner.vue?vue&type=script&lang=js"
export * from "./stories_inner.vue?vue&type=script&lang=js"
import style0 from "./stories_inner.vue?vue&type=style&index=0&id=6aa0ba68&prod&lang=css"
import style1 from "./stories_inner.vue?vue&type=style&index=1&id=6aa0ba68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa0ba68",
  null
  
)

export default component.exports